import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as postActions from '../../../store/action/post'
import * as configActions from '../../../store/action/config'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import { renderFormField, renderTextAreaField } from '../../../utils/reduxField'
import { DraggableAreasGroup } from 'react-draggable-tags'
import * as _ from 'lodash'
import Select from 'react-select'
import CreatorItem from './creator-item/creator-item'
import axios from "axios";
import slug from '@sindresorhus/slugify';
import ApiService from "src/services/ApiService";
import localStore from 'src/utils/local-storage';
import countWordsHTML from 'src/utils/countWordsHTML';

const AI_URL = process.env.REACT_APP_URL_AI;

function safeJSONParse(jsonString) {
  try {
      return JSON.parse(jsonString);
  } catch (error) {
      console.error("JSON parse error:", error.message);
      return null;
  }
}
function extractAllJSONTags(text) {
  // Regex tìm tất cả các đoạn JSON có tags
  const regex = /({\s*"tags"\s*:\s*\[.*?\]\s*})/gs;

  const matches = [...text.matchAll(regex)];
  const allTags = [];

  matches.forEach(match => {
      const jsonString = match[1];

      try {
          // Loại bỏ các ký tự không hợp lệ có thể làm hỏng JSON (optional nếu cần nâng cao hơn)
          const cleanedJsonString = jsonString
              .replace(/,\s*]/g, ']') // Xóa dấu phẩy thừa trước dấu đóng ]
              .replace(/,\s*}/g, '}'); // Xóa dấu phẩy thừa trước dấu đóng }

          const jsonData = JSON.parse(cleanedJsonString);

          if (jsonData.tags && Array.isArray(jsonData.tags)) {
              const cleanedTags = jsonData.tags
                  .map(tag => tag.trim())
                  .filter(tag => tag.length > 0);

              allTags.push(...cleanedTags);
          }
      } catch (err) {
          console.warn("Skip invalid JSON:", jsonString);
      }
  });

  // Xóa tag trùng lặp (nếu có)
  const uniqueTags = [...new Set(allTags)];

  return uniqueTags;
}

class TagRecommendation extends Component {
  constructor() {
    super();
    const aiLimitWords = localStore.get("_aiLimitWord");
    this.state = {
      keywords: [],
      getKeywords: false,
      fetchKeywords : false,
      title: "",
      description: "",
      content: "",
      lengthContent: (aiLimitWords && aiLimitWords.content) ? aiLimitWords.content : 200
    }
  }

  componentDidMount() {
    this.getData();     
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { post: { currentPost }, config: nextConfig } = nextProps || this.props;
    let { title, content, lengthContent } = this.state
    if(currentPost.content && countWordsHTML(currentPost.content) >= lengthContent){
      this.setState({
        content : currentPost.content, 
        title: currentPost.title,
        description: currentPost.description,
        getKeywords: true
      });

      // if (this.timeout) clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //    this.setState({content : currentPost.content, title: currentPost.title}) 
      //    this.suggestAI();
      // }, 5000);

    } else {
      this.setState({
        getKeywords: false
      })
    }

    // this.getData(nextProps);
  }

  getData(props) {
      
     
      
  }

  suggestAI() {
    const scope = this;
    const { post: {currentPost} } = this.props;
    let { title, description, content, lengthContent }  = this.state;
    let tagAIConfig;
    content = this.strip_tags(content);
    if(content && content.length >= lengthContent){
      // console.log("dat - tag");
      // this.setState({
      //   keywords: [
      //     "test2",
      //     "test3"
      //   ]
      // });
      if (localStore.get("_aiConfig")) {
        const aiConfig = localStore.get("_aiConfig");
        tagAIConfig = _.find(aiConfig, function(o) { return o.key === "tag-recommendation"; });
      }
      if(tagAIConfig){
        const token = tagAIConfig.token;
          const requestOptions = {
                method: 'POST',
                url: tagAIConfig.url,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
                },
                data: {
                  "max_tokens": tagAIConfig.max_tokens,
                  "messages": [
                  {
                    "role": "system",
                    "content": tagAIConfig.prompt
                  },
                  {
                    "role": "user",
                    "content": JSON.stringify({
                      title: title,
                      description: description,
                      content: content
                    })
                  }
                  ],
                  "model": tagAIConfig.model,
                  "temperature": tagAIConfig.temperature,
                  "stream": false
                  }
              }
              this.setState({
                fetchKeywords: true
              })
              axios(requestOptions)
                .then(response => {
                  if(response && response.data && response.data.choices && response.data.choices[0].message && response.data.choices[0].message.content){
                      console.log(response.data.choices[0].message.content);
                      
                      let jsonData = safeJSONParse(response.data.choices[0].message.content.replaceAll("```json", "").replaceAll("```", ""));
                      let recommendTags = jsonData ? jsonData.tags : null;
                      if(!jsonData){
                        jsonData = extractAllJSONTags(response.data.choices[0].message.content.replaceAll("```json", "").replaceAll("```", ""));
                        recommendTags = jsonData;
                      }
                      console.log(jsonData);
                      console.log(recommendTags);
                      this.setState({
                          keywords: recommendTags,
                          fetchKeywords: false
                      });
                  }
          
                })
                .catch(function (error) {
                  console.log(error);
                });
        }
      }
  }

  strip_tags(input, allowed) {
    allowed = (((allowed || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('')
    const tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi
    return input.replace(tags, ($0, $1) => (allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : ''))
  }

  createTag = (inputValue) => {

    const { post: {currentPost} } = this.props;
    let tags = currentPost.tags;
    if(!_.some(tags, {'slug': slug(inputValue)})){
      let data = {
        label: inputValue,
        active: true,
        status: true,
        slug: slug(inputValue),
        increment_id: Math.floor(Math.random() * (10000))
      }
      ApiService.post("/tags", data).then(result => {
        this.updateTagForPost(result)
      });
    }
    
    
  };
  updateTagForPost(result){
    const { post: {currentPost} } = this.props;
    let tags = currentPost.tags;
    console.log(result);
    
    if(!_.some(tags, {'id': result.id})){
      if(!tags){
        tags = [result]
      }else{

        tags = _.concat(tags, result);
      }
      // tags = tags.push(result);

      currentPost.tags = tags;
      this.props.setCurrentPost(currentPost);
    }
  }

  render() {
    const { keywords, getKeywords, fetchKeywords } = this.state;
    return (
      (
        getKeywords && 
        <div className="row mb-4">
          <div className="col-12">
            <label className="d-block">Tag gợi ý</label>
            {!fetchKeywords && keywords.length > 0 ?
              (
                keywords.map((word, idx) => {
                  return (
                    <span
                      style={{ padding: ".35rem .4rem 0.45rem .4rem" }}
                      className="btn btn-xs bg-gradient-info mr-2 mt-2"
                      key={idx}
                      onClick={(e) => this.createTag(word)}
                    >
                      {word}
                    </span>
                  );
                })
              ) : (
                <></>
              )
            }
            {
              fetchKeywords && keywords.length <= 0 ?
              <button type="button" className="btn btn-primary">
                <i className="fas fa-spinner fa-spin"></i>
              </button>
              :
              <></>
            }
            {
              !fetchKeywords && keywords.length <= 0 ?
              <button type="button" className="btn btn-ai-recommend" onClick={(e) => this.suggestAI()}>
                <span className="mr-2">
                <svg fillRule="evenodd" viewBox="64 64 896 896" focusable="false" dataIcon="open-a-i" width="16px" height="16px" fill="currentColor" ariaHidden="true"><path d="M482.88 128c-84.35 0-156.58 52.8-185.68 126.98-60.89 8.13-115.3 43.63-146.6 97.84-42.16 73-32.55 161.88 17.14 224.16-23.38 56.75-19.85 121.6 11.42 175.78 42.18 73.02 124.1 109.15 202.94 97.23C419.58 898.63 477.51 928 540.12 928c84.35 0 156.58-52.8 185.68-126.98 60.89-8.13 115.3-43.62 146.6-97.84 42.16-73 32.55-161.88-17.14-224.16 23.38-56.75 19.85-121.6-11.42-175.78-42.18-73.02-124.1-109.15-202.94-97.23C603.42 157.38 545.49 128 482.88 128m0 61.54c35.6 0 68.97 13.99 94.22 37.74-1.93 1.03-3.92 1.84-5.83 2.94l-136.68 78.91a46.11 46.11 0 00-23.09 39.78l-.84 183.6-65.72-38.34V327.4c0-76 61.9-137.86 137.94-137.86m197.7 75.9c44.19 3.14 86.16 27.44 109.92 68.57 17.8 30.8 22.38 66.7 14.43 100.42-1.88-1.17-3.6-2.49-5.53-3.6l-136.73-78.91a46.23 46.23 0 00-46-.06l-159.47 91.1.36-76.02 144.5-83.41a137.19 137.19 0 0178.53-18.09m-396.92 55.4c-.07 2.2-.3 4.35-.3 6.56v157.75a46.19 46.19 0 0022.91 39.9l158.68 92.5-66.02 37.67-144.55-83.35c-65.86-38-88.47-122.53-50.45-188.34 17.78-30.78 46.55-52.69 79.73-62.68m340.4 79.93l144.54 83.35c65.86 38 88.47 122.53 50.45 188.34-17.78 30.78-46.55 52.69-79.73 62.68.07-2.19.3-4.34.3-6.55V570.85a46.19 46.19 0 00-22.9-39.9l-158.69-92.5zM511.8 464.84l54.54 31.79-.3 63.22-54.84 31.31-54.54-31.85.3-63.16zm100.54 58.65l65.72 38.35V728.6c0 76-61.9 137.86-137.94 137.86-35.6 0-68.97-13.99-94.22-37.74 1.93-1.03 3.92-1.84 5.83-2.94l136.68-78.9a46.11 46.11 0 0023.09-39.8zm-46.54 89.55l-.36 76.02-144.5 83.41c-65.85 38-150.42 15.34-188.44-50.48-17.8-30.8-22.38-66.7-14.43-100.42 1.88 1.17 3.6 2.5 5.53 3.6l136.74 78.91a46.23 46.23 0 0046 .06z"></path></svg>
                </span>
                Gợi ý AI
              </button>
              :
              <></>
            }
          </div>
        </div>
      )
      
    )
  }
};

export default connect(store => {
  return {
    post: store.post,
    config: store.config,
  };
}, dispatch => {
  return {
    setCurrentPost: (value) => { dispatch(postActions.setCurrentPost(value)) },
    createNewTag: (value) => { dispatch(configActions.createNewTag(value)) },
  }
})(TagRecommendation)
